import { Outlet } from 'react-router';

import { AuthProvider } from '@features/auth';
import { ConsentBanner } from '@features/consent';

/**
 * Корневой маршрут над всеми оболочками.
 *
 * Нужен ровно для одного: окно входа должно быть единственным на приложение и
 * при этом жить внутри роутера (после успеха оно навигирует). Провайдер выше
 * `RouterProvider` разместить нельзя — там ещё нет контекста навигации.
 *
 * Здесь же — баннер согласия: он общий на приложение, а внутри роутера он
 * нужен потому, что ссылается на Cookie-Richtlinie. Ничего не рисуется, пока
 * оператор не объявил ни одной необязательной технологии, — спрашивать
 * согласие не на что (§ 25 Abs. 2 TDDDG).
 */
export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
      <ConsentBanner />
    </AuthProvider>
  );
}
